import axiosInstance from '../axios';
import axios from 'axios'; // Import standard axios for direct S3 uploads

/**
 * Get a pre-signed URL from the backend for direct upload to S3
 *
 * @param file The file to upload
 * @param folderName Optional folder name to organize uploads in S3
 * @returns The final URL where the file will be accessible after upload
 */
export const uploadFileToS3 = async (
  file: File,
  folderName = 'project-images'
): Promise<string> => {
  try {
    console.log('S3Upload: Starting upload process for file:', file.name, 'type:', file.type);

    // Step 1: Get a pre-signed URL from the backend
    // Using axiosInstance to include auth headers for our backend API
    console.log('S3Upload: Requesting presigned URL with params:', {
      contentType: file.type,
      folderName,
      filename: file.name,
    });

    const response = await axiosInstance.get('/v1/admin/s3/presigned-url', {
      params: {
        contentType: file.type,
        folderName,
        filename: file.name,
      },
    });

    console.log('S3Upload: Received response from presigned URL endpoint:', response.data);

    const { presignedUrl, fileUrl } = response.data.data;

    if (!presignedUrl || !fileUrl) {
      console.error('S3Upload: Invalid presigned URL response - missing required fields');
      throw new Error('Invalid presigned URL response from server');
    }

    console.log('S3Upload: Got presigned URL:', presignedUrl.substring(0, 100) + '...');
    console.log('S3Upload: Expected final file URL:', fileUrl);

    // Step 2: Use the pre-signed URL to upload the file directly to S3
    console.log('S3Upload: Uploading file directly to S3...');
    await axios.put(presignedUrl, file, {
      headers: {
        'Content-Type': file.type,
      },
    });

    console.log('S3Upload: File successfully uploaded to S3, final URL:', fileUrl);

    // Return the final URL where the file can be accessed
    return fileUrl;
  } catch (error) {
    console.error('S3Upload: Error uploading file to S3:', error);
    if (axios.isAxiosError(error)) {
      console.error('S3Upload: Response details:', error.response?.data);
      console.error('S3Upload: Status:', error.response?.status);
      console.error('S3Upload: Headers:', error.response?.headers);
    }
    throw new Error('Failed to upload file to S3');
  }
};
